export interface Language {
    key: string;
    name: string;
    flag: string;
    enabled: boolean;
}
